import { Property } from '../../../types';

/**
 * Checks if a property belongs to "NEGOCIACION_ESPECIAL" or "NEGOCIACION-ESPECIAL".
 * Normalizes hyphens, underscores, accents, and casing.
 */
export const isNegociacionEspecial = (property: Property | null | undefined): boolean => {
  if (!property) return false;

  const valuesToCheck = [
    property.estrategiaComercial,
    property.owner,
    (property as any).tipo_negociacion,
    (property as any).tipoNegociacion,
    (property as any).negociacion,
    (property as any).estrategia_comercial,
    property.status,
    ...(Array.isArray(property.features) ? property.features : [])
  ];

  return valuesToCheck.some((val) => {
    if (!val || typeof val !== 'string') return false;
    const normalized = val
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();

    return (
      normalized.includes('NEGOCIACION_ESPECIAL') ||
      normalized.includes('NEGOCIACION-ESPECIAL') ||
      normalized.includes('NEGOCIACION ESPECIAL')
    );
  });
};
